import { Trans } from '@lingui/macro'

import * as React from 'react'

import { useTrans } from '~logic/i18n/useTrans'
import { Controller, useFormContext } from '~shared/segments/Form'
import { PaymentMethodSelect } from '~shared/segments/PaymentMethods'
import { InputControl } from '~ui/components/formElements/accessories/InputControl'
import { InputGroup } from '~ui/components/formElements/accessories/InputGroup'
import { InputLabel } from '~ui/components/formElements/accessories/InputLabel'
import { InputHelperMessage } from '~ui/components/formElements/accessories/InputMessages'

import { useAvailablePaymentMethodsCtx } from '../'
import { TOrderForm } from '../../FormScreen/contexts/FormProvider'
import { TipInput } from './TipInput'

type TProps = NoChildren

/**
 * Group of payment selection input
 * and the associated tip selection input.
 */
export const PaymentMethod: React.FC<TProps> = () => {
  const { trans } = useTrans()
  const { control } = useFormContext<TOrderForm>()
  const { availableMethods, availableMethodsMessages } = useAvailablePaymentMethodsCtx()

  return (
    <InputGroup>
      <InputControl>
        <InputLabel>
          <Trans>Payment method</Trans>
        </InputLabel>
        <Controller
          control={control}
          name={`paymentMethod`}
          rules={{ required: true }}
          render={({
            field: { onChange, value }, //
            formState: { isSubmitting },
          }) => (
            <PaymentMethodSelect
              onSelect={onChange}
              selectedMethod={value}
              availableMethods={availableMethods}
              isDisabled={isSubmitting}
            />
          )}
        />

        {/* if any of the payment methods was filtered out, display the message with the reason */}
        {availableMethodsMessages?.map((message) => (
          <InputHelperMessage
            key={message.id}
            padding={{
              top: `small`,
              left: `small`,
              right: `none`,
              bottom: `none`,
            }}
          >
            {trans(message)}
          </InputHelperMessage>
        ))}
      </InputControl>
      <TipInput />
    </InputGroup>
  )
}
